export const getBrowserLocales = (
  /**
   * If a fallback is given, it will be returned as part of the inferred browser locales
   * on the last position.
   */
  fallback?: string
): readonly string[] => {
  try {
    return [...window.navigator.languages, fallback].filter(Boolean) as string[]
  } catch (originalError) {
    return [fallback].filter(Boolean) as string[]
  }
}

export const formatNumberInUserLocale = (
  /** The value to be formatted */
  value: string,
  /** Formatting options */
  options: Intl.NumberFormatOptions = {
    useGrouping: false
  },
  /**
   * Pass `undefined` to use the runtime's default locale when none of the browser
   * locales are supported.
   */
  fallback: string | undefined = 'de-DE'
) => {
  const cleanedValue = value.replace(/[^\d,.]/g, '')
  const number = parseFloat(cleanedValue.replace(',', '.'))

  if (isNaN(number)) return value

  try {
    return new Intl.NumberFormat(getBrowserLocales(fallback), options).format(
      number
    )
  } catch (originalError) {
    const error = new Error('Failed to format number in user locale')

    error.cause = originalError

    // eslint-disable-next-line no-console
    console.warn(error)

    return new Intl.NumberFormat(undefined, options).format(number)
  }
}
